// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-list-item__subtitle{overflow:visible!important;white-space:normal!important}", ""]);
// Exports
module.exports = exports;
